import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { SlidersHorizontal, LayoutPanelTop, CircleDot } from "lucide-react";
import { MEMBER_SECTIONS } from "@/lib/portalView";

const MODES = [{ id: "expanded", label: "Expanded", icon: LayoutPanelTop }, { id: "icon", label: "Icon", icon: CircleDot }];

export default function CustomizeViewButton({ view, onChange, disabled }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" disabled={disabled} data-testid="customize-view-btn"
                className="inline-flex items-center gap-2 h-9 px-4 rounded-full text-sm font-medium transition-colors hover:bg-[color:var(--bg-soft)] disabled:opacity-50"
                style={{ border: "1px solid var(--border)", color: "var(--text)" }}>
          <SlidersHorizontal className="h-4 w-4" /> Customize my view
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" collisionPadding={12} className="w-[min(20rem,calc(100vw-24px))]" data-testid="customize-view-panel">
        <div className="font-semibold text-sm">Customize my view</div>
        <p className="text-xs mt-0.5" style={{ color: "var(--text-muted)" }}>
          Show a section in full, or as an icon you can tap to open. Saved to your account.
        </p>
        <ul className="mt-4 space-y-3">
          {Object.entries(MEMBER_SECTIONS).map(([id, s]) => (
            <li key={id} className="flex items-center justify-between gap-3">
              <span className="inline-flex items-center gap-2 text-sm"><s.icon className="h-4 w-4" style={{ color: "var(--gold)" }} />{s.label}</span>
              <div role="radiogroup" aria-label={`${s.label} display`} className="inline-flex p-0.5 rounded-full"
                   style={{ background: "var(--bg-soft)", border: "1px solid var(--border)" }}>
                {MODES.map((m) => {
                  const on = view[id] === m.id;
                  return (
                    <button key={m.id} type="button" role="radio" aria-checked={on} onClick={() => !on && onChange(id, m.id)}
                            data-testid={`view-mode-${id}-${m.id}`}
                            className="h-7 px-3 rounded-full text-xs font-medium inline-flex items-center gap-1 transition-colors"
                            style={on ? { background: "var(--navy)", color: "#fff" } : { color: "var(--text-muted)" }}>
                      <m.icon className="h-3 w-3" />{m.label}
                    </button>
                  );
                })}
              </div>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
